import { render, staticRenderFns } from "./ICD10Table.vue?vue&type=template&id=4904d3af&scoped=true"
import script from "./ICD10Table.vue?vue&type=script&lang=js"
export * from "./ICD10Table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4904d3af",
  null
  
)

export default component.exports